import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainButton from "../../Elements/MainButton/MainButton";
import emptySimIcon from "../../../assets/icons/cart/sim-card.png";

import "./EmptyEsimView.css";

const EmptyEsimView = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";
  return (
    <div className="esim-empty-container">
      <section className="esim-empty-content">
        <img
          src={emptySimIcon}
          alt={t("esim.noEsims", "No eSIMs")}
          className="esim-empty__img"
          aria-hidden="true"
        />
        <h2 className="esim-empty__title">{t("esim.empty.title", "No eSIMs Yet")}</h2>
        <p className="esim-empty__lead">
          {t(
            "esim.empty.lead",
            "Purchase your first eSIM profile to start connecting globally. It only takes a few minutes!"
          )}
        </p>
        <Link to={`/${lang}/shop`} className="esim-empty__cta">
          <MainButton type="button">{t("esim.empty.buyButton", "Buy your first eSIM")}</MainButton>
        </Link>
      </section>
    </div>
  );
};

export default EmptyEsimView;
